/**
 * Configurateur bouteille + cire (Fabric 5). Initialisé par initBottleConfiguratorSection(root, config).
 * config: { canvasId, colors: [{t,h, children?: [{t,h}]}], strings: {...}, devisUrl }
 */
(function () {
  'use strict';

  function isRasterWaxUrl(url) {
    if (!url || typeof url !== 'string') return true;
    return !/\.svg(\?|$)/i.test(url.split('?')[0]);
  }

  window.initBottleConfiguratorSection = function (root, config) {
    if (!root) return;
    var colors = (config && config.colors && config.colors.length) ? config.colors : [
      { t: 'RD009', h: '#A9011A' }
    ];
    var S = (config && config.strings) ? config.strings : {};
    var devisUrl = (config && config.devisUrl) ? config.devisUrl : '';
    var deviseUrl = (config && config.deviseUrl) ? config.deviseUrl : '';

    var stage = root.querySelector('[data-bottle-stage]');
    var loading = root.querySelector('[data-bottle-loading]');
    var loadingText = root.querySelector('[data-bottle-loading-text]');
    var statusEl = root.querySelector('[data-bottle-status]');
    var canvasEl = root.querySelector('[data-bottle-canvas]');
    var fileInput = root.querySelector('[data-bottle-file]');
    var btnDownload = root.querySelector('[data-bottle-download]');
    var btnDevis = root.querySelector('[data-bottle-devis]');
    var btnDevise = root.querySelector('[data-bottle-devise]');
    var devisBlock = root.querySelector('[data-bottle-devis-block]');
    var colorsGrid = root.querySelector('[data-bottle-colors]');

    if (!stage || !canvasEl || typeof fabric === 'undefined') {
      if (stage) stage.innerHTML = '<p style="padding:24px;text-align:center;">' + (S.fabric_error || 'Fabric.js indisponible.') + '</p>';
      return;
    }

    var currentHex = colors[0].h;
    var wax = null;
    var bottle = null;
    var waxTransform = null;

    function setStatus(msg) { if (statusEl) statusEl.textContent = msg || ''; }

    function showLoading(on, text) {
      if (loadingText) loadingText.textContent = text || S.loading_default || 'Traitement…';
      if (loading) loading.classList.toggle('is-on', !!on);
    }

    function stageSize() {
      var r = stage.getBoundingClientRect();
      return { w: Math.max(280, Math.floor(r.width)), h: Math.max(280, Math.floor(r.height)) };
    }

    var wh0 = stageSize();
    var canvas = new fabric.Canvas(canvasEl, {
      width: wh0.w,
      height: wh0.h,
      backgroundColor: 'transparent',
      preserveObjectStacking: true
    });
    canvas.uniformScaling = true;

    fabric.Object.prototype.set({
      transparentCorners: false,
      cornerColor: '#d90000',
      cornerStrokeColor: '#fff',
      borderColor: '#d90000',
      cornerSize: 11,
      padding: 8,
      cornerStyle: 'circle',
      lockUniScaling: true,
      lockSkewingX: true,
      lockSkewingY: true
    });

    function restrictToRotateAndUniformScale(obj) {
      if (!obj || typeof obj.setControlsVisibility !== 'function') return;
      obj.set({ lockUniScaling: true, lockSkewingX: true, lockSkewingY: true });
      obj.setControlsVisibility({
        mt: false, mb: false, ml: false, mr: false,
        tl: true, tr: true, br: true, bl: true, mtr: true
      });
      if (typeof obj.setCoords === 'function') obj.setCoords();
    }

    function resizeCanvas() {
      var wh = stageSize();
      if (wh.w < 8 || wh.h < 8) return;
      canvas.setWidth(wh.w);
      canvas.setHeight(wh.h);
      canvas.requestRenderAll();
    }

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(resizeCanvas).observe(stage);
    }
    window.addEventListener('resize', resizeCanvas);
    requestAnimationFrame(function () { requestAnimationFrame(resizeCanvas); });

    function snapshotCanvasPng(multiplier) {
      var prev = canvas.getActiveObject();
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      var oldBg = canvas.backgroundColor;
      canvas.backgroundColor = '#f0f0f0';
      canvas.requestRenderAll();
      var dataURL = canvas.toDataURL({ format: 'png', quality: 1, multiplier: multiplier || 1 });
      canvas.backgroundColor = oldBg;
      canvas.requestRenderAll();
      if (prev) canvas.setActiveObject(prev);
      canvas.requestRenderAll();
      return dataURL;
    }

    if (btnDownload) {
      btnDownload.addEventListener('click', function () {
        var dataURL = snapshotCanvasPng(2);
        var a = document.createElement('a');
        a.href = dataURL;
        a.download = (S.download_filename || 'configurateur-apercu') + '.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setStatus(S.download_done || '');
      });
    }

    if (btnDevis && devisUrl) {
      btnDevis.addEventListener('click', function () {
        if (!bottle) return;
        window.location.href = devisUrl;
      });
    }

    if (btnDevise && deviseUrl) {
      btnDevise.addEventListener('click', function () {
        window.location.href = deviseUrl;
      });
    }

    function paintWax() {
      if (!wax) return;
      if (wax.type === 'image') return;
      if (wax.type === 'path') wax.set({ fill: currentHex });
      else if (wax._objects) wax._objects.forEach(function (o) { if (o.set) o.set({ fill: currentHex }); });
      canvas.requestRenderAll();
    }

    function applyWaxTransform(target) {
      var defaultScale = 0.06;
      if (waxTransform) {
        target.set(Object.assign({}, waxTransform, {
          skewX: 0,
          skewY: 0,
          hasControls: true,
          hasBorders: true
        }));
      } else {
        target.set({
          left: canvas.getWidth() / 2,
          top: canvas.getHeight() * 0.22,
          originX: 'center',
          originY: 'center',
          scaleX: defaultScale,
          scaleY: defaultScale,
          skewX: 0,
          skewY: 0,
          hasControls: true,
          hasBorders: true
        });
      }
    }

    function loadWaxRaster(url, noCors) {
      var opts = noCors ? {} : { crossOrigin: 'anonymous' };
      fabric.Image.fromURL(url, function (img) {
        if (!img) {
          if (!noCors) {
            loadWaxRaster(url, true);
            return;
          }
          setStatus(S.wax_load_error || '');
          return;
        }
        if (wax) {
          waxTransform = {
            left: wax.left,
            top: wax.top,
            angle: wax.angle,
            scaleX: wax.scaleX,
            scaleY: wax.scaleY,
            originX: wax.originX,
            originY: wax.originY
          };
          canvas.remove(wax);
        }
        applyWaxTransform(img);
        wax = img;
        restrictToRotateAndUniformScale(wax);
        canvas.add(wax);
        wax.bringToFront();
        canvas.setActiveObject(wax);
        canvas.requestRenderAll();
        setStatus('');
      }, opts);
    }

    function loadWaxSvg(url) {
      fabric.loadSVGFromURL(url, function (objects, options) {
        if (!objects || !objects.length) {
          setStatus(S.wax_load_error || '');
          return;
        }
        if (wax) {
          waxTransform = {
            left: wax.left,
            top: wax.top,
            angle: wax.angle,
            scaleX: wax.scaleX,
            scaleY: wax.scaleY,
            originX: wax.originX,
            originY: wax.originY
          };
          canvas.remove(wax);
        }
        var g = fabric.util.groupSVGElements(objects, options);
        applyWaxTransform(g);
        wax = g;
        restrictToRotateAndUniformScale(wax);
        paintWax();
        canvas.add(wax);
        wax.bringToFront();
        canvas.setActiveObject(wax);
        canvas.requestRenderAll();
        setStatus('');
      });
    }

    function loadWax(url) {
      if (isRasterWaxUrl(url)) loadWaxRaster(url, false);
      else loadWaxSvg(url);
    }

    if (colorsGrid) {
      function closeAllColorDropdowns() {
        colorsGrid.querySelectorAll('.cfg-color-wrap.is-open').forEach(function (w) { w.classList.remove('is-open'); });
      }
      document.addEventListener('click', function (ev) {
        if (!colorsGrid.contains(ev.target)) closeAllColorDropdowns();
      });
      function clearAllColorActives() {
        colorsGrid.querySelectorAll('.swatch.active, .cfg-child-swatch.active').forEach(function (el) { el.classList.remove('active'); });
      }
      function applyWaxColor(hex) {
        currentHex = hex;
        paintWax();
      }
      colors.forEach(function (c, i) {
        var cell = document.createElement('div');
        cell.className = 'color-cell';
        var hasChildren = Array.isArray(c.children) && c.children.length > 0;
        var lab = document.createElement('span');
        lab.className = 'swatch-title cfg-color-label';
        if (!hasChildren) {
          var s = document.createElement('button');
          s.type = 'button';
          s.className = 'swatch' + (i === 0 ? ' active' : '');
          s.style.background = c.h;
          s.title = c.t;
          lab.textContent = c.t;
          s.addEventListener('click', function (ev) {
            ev.stopPropagation();
            closeAllColorDropdowns();
            clearAllColorActives();
            s.classList.add('active');
            applyWaxColor(c.h);
            lab.textContent = c.t;
          });
          cell.appendChild(s);
          cell.appendChild(lab);
        } else {
          var wrap = document.createElement('div');
          wrap.className = 'cfg-color-wrap';
          var mainSw = document.createElement('button');
          mainSw.type = 'button';
          mainSw.className = 'swatch cfg-parent-swatch' + (i === 0 ? ' active' : '');
          mainSw.style.background = c.h;
          mainSw.title = c.t + ' — nuances';
          lab.textContent = c.t;
          var dropdown = document.createElement('div');
          dropdown.className = 'cfg-color-dropdown';
          dropdown.setAttribute('role', 'listbox');
          c.children.forEach(function (ch) {
            var row = document.createElement('div');
            row.className = 'cfg-dropdown-row';
            var chBtn = document.createElement('button');
            chBtn.type = 'button';
            chBtn.className = 'cfg-child-swatch';
            chBtn.style.background = ch.h;
            chBtn.title = ch.t;
            chBtn.setAttribute('aria-label', ch.t);
            var chLab = document.createElement('span');
            chLab.className = 'cfg-child-title';
            chLab.textContent = ch.t;
            chBtn.addEventListener('click', function (ev) {
              ev.stopPropagation();
              closeAllColorDropdowns();
              clearAllColorActives();
              mainSw.classList.add('active');
              chBtn.classList.add('active');
              mainSw.style.background = ch.h;
              applyWaxColor(ch.h);
              lab.textContent = ch.t;
            });
            row.appendChild(chBtn);
            row.appendChild(chLab);
            dropdown.appendChild(row);
          });
          mainSw.addEventListener('click', function (ev) {
            ev.stopPropagation();
            var open = wrap.classList.toggle('is-open');
            colorsGrid.querySelectorAll('.cfg-color-wrap.is-open').forEach(function (w) {
              if (w !== wrap) w.classList.remove('is-open');
            });
            if (!open) wrap.classList.remove('is-open');
          });
          wrap.appendChild(mainSw);
          wrap.appendChild(dropdown);
          cell.appendChild(wrap);
          cell.appendChild(lab);
        }
        colorsGrid.appendChild(cell);
      });
    }

    root.querySelectorAll('[data-bottle-type-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var wu = btn.getAttribute('data-wax-url');
        if (!wu) return;
        root.querySelectorAll('[data-bottle-type-btn]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        loadWax(wu);
      });
    });

    function cutWhiteFallback(blob) {
      return new Promise(function (resolve, reject) {
        var u = URL.createObjectURL(blob);
        var im = new Image();
        im.onload = function () {
          try {
            var maxH = 1600;
            var W = im.naturalWidth, H = im.naturalHeight;
            if (H > maxH) {
              W = Math.round((W * maxH) / H);
              H = maxH;
            }
            var off = document.createElement('canvas');
            off.width = W;
            off.height = H;
            var ctx = off.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(im, 0, 0, W, H);
            var imgData = ctx.getImageData(0, 0, W, H);
            var d = imgData.data;
            var tol = 235;
            for (var j = 0; j < d.length; j += 4) {
              if (d[j] > tol && d[j + 1] > tol && d[j + 2] > tol) d[j + 3] = 0;
            }
            ctx.putImageData(imgData, 0, 0);
            off.toBlob(function (b) {
              URL.revokeObjectURL(u);
              b ? resolve(b) : reject(new Error('toBlob'));
            }, 'image/png');
          } catch (e) {
            URL.revokeObjectURL(u);
            reject(e);
          }
        };
        im.onerror = function () { URL.revokeObjectURL(u); reject(new Error('image')); };
        im.src = u;
      });
    }

    async function cutWithAI(blobUrl) {
      var mod = await import('https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.7.0/+esm');
      return mod.removeBackground(blobUrl, {
        publicPath: 'https://staticimgly.com/@imgly/background-removal-data/1.7.0/dist/'
      });
    }

    function trimToOpaqueBounds(blob) {
      return new Promise(function (resolve) {
        var u = URL.createObjectURL(blob);
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var W = im.naturalWidth, H = im.naturalHeight;
            if (W < 2 || H < 2) {
              URL.revokeObjectURL(u);
              resolve(blob);
              return;
            }
            var c = document.createElement('canvas');
            c.width = W;
            c.height = H;
            var ctx = c.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(im, 0, 0);
            var imgData = ctx.getImageData(0, 0, W, H);
            var d = imgData.data;
            var alphaThr = 14;
            var minX = W, minY = H, maxX = -1, maxY = -1;
            var x, y, i, a;
            for (y = 0; y < H; y++) {
              for (x = 0; x < W; x++) {
                i = (y * W + x) * 4;
                a = d[i + 3];
                if (a > alphaThr) {
                  if (x < minX) minX = x;
                  if (x > maxX) maxX = x;
                  if (y < minY) minY = y;
                  if (y > maxY) maxY = y;
                }
              }
            }
            URL.revokeObjectURL(u);
            if (maxX < minX || maxY < minY) {
              resolve(blob);
              return;
            }
            var pad = 1;
            minX = Math.max(0, minX - pad);
            minY = Math.max(0, minY - pad);
            maxX = Math.min(W - 1, maxX + pad);
            maxY = Math.min(H - 1, maxY + pad);
            var tw = maxX - minX + 1;
            var th = maxY - minY + 1;
            var c2 = document.createElement('canvas');
            c2.width = tw;
            c2.height = th;
            c2.getContext('2d').drawImage(c, minX, minY, tw, th, 0, 0, tw, th);
            c2.toBlob(function (b) {
              resolve(b || blob);
            }, 'image/png');
          } catch (err) {
            URL.revokeObjectURL(u);
            resolve(blob);
          }
        };
        im.onerror = function () {
          URL.revokeObjectURL(u);
          resolve(blob);
        };
        im.src = u;
      });
    }

    /**
     * @param {string} outUrl - blob: ou object URL à révoquer après chargement
     * @param {string} used - libellé méthode (import détouré uniquement)
     * @param {string|undefined} statusOverride - si défini (y compris ''), remplace le message succès import
     */
    function placeBottleOnCanvasFromBlobUrl(outUrl, used, statusOverride) {
      return new Promise(function (resolve, reject) {
        fabric.Image.fromURL(outUrl, function (img) {
          if (!img) {
            URL.revokeObjectURL(outUrl);
            reject(new Error('Image'));
            return;
          }
          if (bottle) canvas.remove(bottle);
          var ch = canvas.getHeight();
          var cw = canvas.getWidth();
          var scale = (ch * 0.70) / img.height;
          img.set({
            left: cw / 2,
            top: ch / 2,
            originX: 'center',
            originY: 'center',
            scaleX: scale,
            scaleY: scale,
            hasControls: true,
            hasBorders: true,
            perPixelTargetFind: true,
            padding: 0,
            lockUniScaling: true,
            lockSkewingX: true,
            lockSkewingY: true
          });
          bottle = img;
          restrictToRotateAndUniformScale(bottle);
          canvas.add(bottle);
          bottle.sendToBack();
          if (wax) wax.bringToFront();
          canvas.setActiveObject(bottle);
          canvas.requestRenderAll();
          if (devisBlock) devisBlock.hidden = false;
          showLoading(false);
          URL.revokeObjectURL(outUrl);
          if (statusOverride !== undefined) {
            setStatus(statusOverride);
          } else {
            setStatus((S.upload_ok || '') + used + (S.upload_ok_suffix || ''));
          }
          resolve();
        });
      });
    }

    async function processBottleFromObjectURL(objectURL) {
      var outBlob;
      var used;
      try {
        showLoading(true, S.loading_ai || '');
        outBlob = await cutWithAI(objectURL);
        used = 'IA';
      } catch (e1) {
        try {
          showLoading(true, S.loading_fallback || '');
          outBlob = await cutWhiteFallback(await (await fetch(objectURL)).blob());
          used = S.used_fallback || 'fond clair';
        } catch (e2) {
          URL.revokeObjectURL(objectURL);
          throw e2;
        }
      }
      showLoading(true, S.loading_trim || '');
      var tightBlob = await trimToOpaqueBounds(outBlob);
      var outUrl = URL.createObjectURL(tightBlob);
      URL.revokeObjectURL(objectURL);
      await placeBottleOnCanvasFromBlobUrl(outUrl, used);
    }

    /** Modèles bottle_cap : image telle quelle, sans détourage ni recadrage alpha. */
    async function loadPresetBottleFromRemoteUrl(url) {
      showLoading(true, S.loading_prepare || '');
      var res = await fetch(url, { mode: 'cors', credentials: 'omit' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var blob = await res.blob();
      var objectURL = URL.createObjectURL(blob);
      await placeBottleOnCanvasFromBlobUrl(objectURL, '', S.status_model_loaded != null ? S.status_model_loaded : '');
    }

    var bottleMode = 'models';
    var selectedModelUrl = '';

    function updateBottleTabUi() {
      root.querySelectorAll('[data-bottle-tab]').forEach(function (t) {
        var m = t.getAttribute('data-bottle-tab');
        var on = m === bottleMode;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-bottle-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-bottle-panel') !== bottleMode;
      });
    }

    function setBottleMode(mode) {
      if (mode !== 'models' && mode !== 'import') return;
      bottleMode = mode;
      updateBottleTabUi();
      if (mode === 'models' && selectedModelUrl) {
        loadPresetBottleFromRemoteUrl(selectedModelUrl).catch(function (e) {
          showLoading(false);
          setStatus((S.upload_fail || '') + (e && e.message ? e.message : e));
        });
      }
    }

    root.querySelectorAll('[data-bottle-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        setBottleMode(tab.getAttribute('data-bottle-tab'));
      });
    });

    root.querySelectorAll('[data-bottle-model-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.disabled) return;
        var u = card.getAttribute('data-model-url');
        if (!u) return;
        root.querySelectorAll('[data-bottle-model-card]').forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        selectedModelUrl = u;
        if (bottleMode === 'models') {
          loadPresetBottleFromRemoteUrl(u).catch(function (e) {
            showLoading(false);
            setStatus((S.upload_fail || '') + (e && e.message ? e.message : e));
          });
        }
      });
    });

    if (fileInput) {
      fileInput.addEventListener('change', async function (ev) {
        var file = ev.target.files && ev.target.files[0];
        ev.target.value = '';
        if (!file) return;
        setBottleMode('import');
        showLoading(true, S.loading_prepare || '');
        var objectURL = URL.createObjectURL(file);
        try {
          await processBottleFromObjectURL(objectURL);
        } catch (e2) {
          showLoading(false);
          setStatus((S.upload_fail || '') + (e2.message || e2));
        }
      });
    }

    var firstModel = root.querySelector('[data-bottle-model-card][data-model-url]');
    if (firstModel) {
      selectedModelUrl = firstModel.getAttribute('data-model-url');
      bottleMode = 'models';
      updateBottleTabUi();
      setStatus(S.status_initial || '');
      loadPresetBottleFromRemoteUrl(selectedModelUrl).catch(function (e) {
        showLoading(false);
        setStatus((S.upload_fail || '') + (e && e.message ? e.message : e));
      });
    } else {
      bottleMode = 'import';
      updateBottleTabUi();
      setStatus(S.status_initial_import || S.status_initial || '');
    }

    var firstWax = root.querySelector('[data-bottle-type-btn].active[data-wax-url]')
      || root.querySelector('[data-bottle-type-btn][data-wax-url]');
    var firstWaxUrl = firstWax && firstWax.getAttribute('data-wax-url');
    if (firstWaxUrl) loadWax(firstWaxUrl);
  };
})();